<template>
  <div class="progress-container payment-indicator">
    <div
      :class="showNewUi ? 'new-payment-indicator' : 'payment-indicator'"
      :style="indicatorStyles"
      id="payment-indicator"
    >
      <span class="payment-indicator-text" :style="textStyles">
        {{ indicatorText }}
      </span>
      <span
        class="payment-indicator-sub-text mt-3"
        v-if="showNewUi"
        style="font-size: 0.9rem; font-weight: 300"
      >
        {{ indicatorSubText }}
      </span>
      <button
        v-if="!isPending && !succeeded"
        type="button"
        @click.prevent="$emit('hide')"
        class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
        :style="buttonStyles"
      >
        {{ $t("message.backToCheckout") }}
      </button>
    </div>
    <div class="indicator-footer" v-if="!showNewUi">
      <span v-if="isPending">
        {{
          $t(
            "message.pleaseDoNotRefreshYourBrowserWhilePaymentIsBeingProcessed"
          )
        }}.
      </span>
    </div>
    <div style="margin-top: 12rem">
      <poweredby v-if="showNewUi" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Poweredby from "@/components/shared/poweredby";

export default {
  name: "PaymentIndicator",
  components: { Poweredby },
  props: {
    isPending: {
      type: Boolean,
      required: false,
      default: true,
    },
    succeeded: {
      type: Boolean,
      required: true,
    },
    isPayLater: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["desktopStyles", "viewConfig"]),
    indicatorStyles() {
      if (this.isPending) {
        return {
          backgroundImage: `url(${require("../../../../assets/indicators/payment-processing-circle.gif")})`,
          paddingTop : this.showNewUi? "10px" : "",
        };
      } else if (this.succeeded) {
        if (this.isPayLater) {
          return {
            backgroundImage: `url(${require("../../../../assets/indicators/payment-processing-circle.gif")})`,
            paddingTop : this.showNewUi? "10px" : "",
          };
        }
        return {
          backgroundImage: `url(${require("../../../../assets/indicators/payment-success-circle.svg")}), url(${require("../../../../assets/indicators/payment-success-tick.svg")})`,
          backgroundPosition: "center 25px, center 72px",
          paddingTop : this.showNewUi? "100px" : "",
        };
      } else {
        return {
          backgroundImage: `url(${require("../../../../assets/indicators/payment-failure-circle.svg")}), url(${require("../../../../assets/indicators/payment-failure-close.svg")})`,
          backgroundPosition: "center 25px, center 66px",
        };
      }
    },
    indicatorText() {
      if (this.isPayLater) {
        return this.isPending
            ? this.$t("message.sendingOrderToKitchen")
            : this.succeeded
                ? this.$t("message.orderPlaced").concat('.')
                : this.$t("message.orderCouldNotBeProcessed").concat('.');


      } else {
        return this.isPending
          ? this.$t("message.processingPayment")
          : this.succeeded
          ? this.$t("message.paymentComplete")
          : this.$t("message.paymentCouldNotBeProcessed");
      }
    },
    indicatorSubText() {
      return this.isPending
        ? this.$t(
            "message.pleaseDoNotRefreshYourBrowserWhilePaymentIsBeingProcessed"
          )
        : this.succeeded
        ? ""
        : this.$t("message.checkPaymentAndTryAgain");
    },
    textStyles() {
      let color = "#0049CE";
      color = this.isPending
        ? "#0049CE"
        : this.succeeded
        ? "#00A806"
        : "#F44336";

      return { color, flex: "100% 1 0" };
    },
    buttonStyles() {
      if (this.showNewUi) {
        return {
          ...this.desktopStyles.btn,
          ...this.desktopStyles.desktopPlaceOrderButton,
          marginTop: "7rem",
          marginBottom: "-75px !important",
          width: "90vw",
        };
      }
      return {
        ...this.desktopStyles.btn,
        ...this.desktopStyles.desktopPlaceOrderButton,
        marginTop: "25px",
        marginBottom: "-75px !important",
      };
    },
    showNewUi() {
      // temporarily return false for show new UI
      return false
    },
  },
};
</script>
